import(/* webpackMode: "eager" */ "/home/runner/work/OY-Belleza/OY-Belleza/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/OY-Belleza/OY-Belleza/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["LandingAnalytics"] */ "/home/runner/work/OY-Belleza/OY-Belleza/src/components/analytics/LandingAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StickyFooterCTA"] */ "/home/runner/work/OY-Belleza/OY-Belleza/src/components/layout/StickyFooterCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BookingStorySection"] */ "/home/runner/work/OY-Belleza/OY-Belleza/src/components/sections/BookingStorySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FinalCtaSection"] */ "/home/runner/work/OY-Belleza/OY-Belleza/src/components/sections/FinalCtaSection.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/OY-Belleza/OY-Belleza/src/components/ui/HorizontalCardRail.tsx");
